import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Grid, makeStyles } from '@material-ui/core';
import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { FORM } from '../../../constants/props';
import { interviewSchema } from '../../../constants/schemas';
import Input from '../../common/input';

const useStyles = makeStyles((theme) => ({
  left: {
    [theme.breakpoints.up('sm')]: {
      marginRight: '1.25rem',
    },
  },
  button: {
    marginTop: '2.875rem',
    ['@media (max-width:420px)']: {
      marginTop: '0.5rem',
    },
  },
}));

const InterviewForm = ({ disabled, onSubmit }) => {
  const classes = useStyles();
  const { control, handleSubmit, errors } = useForm({
    resolver: yupResolver(interviewSchema),
  });

  return (
    <form>
      <Grid container>
        <Grid className={classes.left} item container xs={12} sm={5}>
          <Controller
            control={control}
            name="fullName"
            defaultValue=""
            render={({ onChange, value }) => (
              <Input
                value={value}
                placeholder="Full name"
                invalid={errors && errors.fullName}
                message={errors && errors.fullName && errors.fullName.message}
                onChange={onChange}
              />
            )}
          />
          <Controller
            control={control}
            name="email"
            defaultValue=""
            render={({ onChange, value }) => (
              <Input
                value={value}
                placeholder="Email"
                type="email"
                invalid={errors && errors.email}
                message={errors && errors.email && errors.email.message}
                onChange={onChange}
              />
            )}
          />
          <Controller
            control={control}
            name="company"
            defaultValue=""
            render={({ onChange, value }) => (
              <Input
                value={value}
                placeholder="Company"
                invalid={errors && errors.company}
                message={errors && errors.company && errors.company.message}
                onChange={onChange}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm>
          <Controller
            control={control}
            name="availability"
            defaultValue=""
            render={({ onChange, value }) => (
              <Input
                value={value}
                placeholder="Available Dates & Times"
                textarea
                rows={5}
                resize="none"
                invalid={errors && errors.availability}
                message={
                  errors && errors.availability && errors.availability.message
                }
                onChange={onChange}
              />
            )}
          />
        </Grid>
      </Grid>
      <Grid container justify="center">
        <Button
          disabled={disabled}
          className={classes.button}
          variant="contained"
          color="primary"
          onClick={handleSubmit(onSubmit)}
        >
          Schedule an interview
        </Button>
      </Grid>
    </form>
  );
};

InterviewForm.defaultValue = {
  disabled: false,
};

InterviewForm.propTypes = {
  FORM,
};

export default InterviewForm;
